import React from "react";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";

import "./Testimonial.scss";

function Testimonial() {
  return (
    <section id="testimonial">
      <div className="wrapper">
        <LazyLoad className="photo-wrapper" offset={800} once>
          <img src="images/testimonial-photo.jpg" alt="" />
        </LazyLoad>
        <div className="text">
          <p>
            <FormattedMessage id="home.testimonial.text" />
          </p>
          <span>
            <FormattedMessage id="home.testimonial.name" />
          </span>
        </div>
      </div>
    </section>
  );
}

export default Testimonial = React.memo(Testimonial);
